<template>
  <vx-card no-shadow>
    <vs-popup
      fullscreen
      :title="popupTitle"
      :active.sync="popupActive"
      v-if="currentTemplate != null"
    >
      <b>Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="customer"
            label-placeholder="Label"
            v-model="currentTemplate.customerName"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="remarks"
            label-placeholder="Remarks"
            v-model="currentTemplate.remarks"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half"></div>
        <br />
      </div>
      <hr />
      <br />

      <!-- Preset Modes Section -->
      <b>Preset Modes</b> <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-settings"
            @click="applyPreset('LPJ')"
            >LPJ (Johor Port Authority)</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-settings"
            @click="applyPreset('XINHWA')"
            >XINHWA</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-settings"
            @click="applyPreset('MPOB')"
            >MPOB</vs-button
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-settings"
            @click="applyPreset('CIMA')"
            >CIMA</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-settings"
            @click="applyPreset('LPK')"
            >LPK (Klang Port Authority)</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="warning"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-refresh-cw"
            @click="clearPreset"
            >Clear Preset</vs-button
          >
        </div>
      </div>
      <hr />
      <br />

      <b>Assign Group</b> <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Assign Units by Group</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect
            :fields="parameterFieldsGroups"
            v-model="currentTemplate.groups"
            :dataSource="groupData"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Assign Units"
          ></ejs-multiselect>
        </div>
        <br />
      </div>
      <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>IP List</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addIP('add')"
            >Add Item</vs-button
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-3/3 w-full">
          <vs-table stripe :data="currentTemplate.ip" max-height="500">
            <template slot="thead">
              <vs-th width="2%">No.</vs-th>
              <vs-th width="8%">Name</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Protocol</vs-th>
              <vs-th width="7%">IP</vs-th>
              <vs-th width="5%">Port</vs-th>
              <vs-th>Format</vs-th>
              <vs-th>Identifier</vs-th>
              <vs-th width="5%">Separator</vs-th>
              <vs-th width="3%">Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.ip[indextr].name"
                    label-placeholder="Label"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <ejs-multiselect
                    id="multiselect"
                    :fields="parameterFieldsStandard"
                    v-model="currentTemplate.ip[indextr].type"
                    maximumSelectionLength="1"
                    :dataSource="parameterOptionsTypes"
                    showClearButton="false"
                    popupHeight="400px"
                    mode="CheckBox"
                    enableGroupCheckBox="false"
                    showDropDownIcon="true"
                    allowFiltering="true"
                    filterType="contains"
                    filterBarPlaceholder="Search"
                    showSelectAll="false"
                    placeholder="Select Type"
                  ></ejs-multiselect>
                </vs-td>
                <vs-td>
                  <ejs-multiselect
                    id="multiselect"
                    :fields="parameterFieldsStandard"
                    v-model="currentTemplate.ip[indextr].protocol"
                    maximumSelectionLength="1"
                    :dataSource="parameterOptionsProtocol"
                    showClearButton="false"
                    popupHeight="400px"
                    mode="CheckBox"
                    enableGroupCheckBox="false"
                    showDropDownIcon="true"
                    allowFiltering="true"
                    filterType="contains"
                    filterBarPlaceholder="Search"
                    showSelectAll="false"
                    placeholder="Select Protocol"
                  ></ejs-multiselect>
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.ip[indextr].ip"
                    label-placeholder="IP"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.ip[indextr].port"
                    label-placeholder="Port"
                    type="number"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <ejs-multiselect
                    id="multiselect"
                    :fields="parameterFieldsStandard"
                    v-model="currentTemplate.ip[indextr].format"
                    :multiple="true"
                    :dataSource="parameterOptionsFormat"
                    showClearButton="false"
                    popupHeight="400px"
                    mode="CheckBox"
                    enableGroupCheckBox="false"
                    showDropDownIcon="true"
                    allowFiltering="true"
                    filterType="contains"
                    filterBarPlaceholder="Search"
                    showSelectAll="false"
                    placeholder="Select Format"
                  ></ejs-multiselect>
                </vs-td>
                <vs-td>
                  <ejs-multiselect
                    id="multiselect"
                    :fields="parameterFieldsStandard"
                    v-model="currentTemplate.ip[indextr].identifier"
                    :multiple="true"
                    :dataSource="parameterOptionsIdentifier"
                    showClearButton="false"
                    popupHeight="400px"
                    mode="CheckBox"
                    enableGroupCheckBox="false"
                    showDropDownIcon="true"
                    allowFiltering="true"
                    filterType="contains"
                    filterBarPlaceholder="Search"
                    showSelectAll="false"
                    placeholder="Select Identifier"
                  ></ejs-multiselect>
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="currentTemplate.ip[indextr].separator"
                    label-placeholder="Separator"
                    type="number"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeIP(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <vs-button
        v-if="mode == 'add'"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="postData('add')"
        >Add New Data Push Subscription</vs-button
      >
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Data Push: <b>{{ currentTemplate.create_time }}</b>
          </div>
          <div
            class="vx-col md:w-1/4 w-half"
            v-if="currentTemplate.update_time != null"
          >
            Last Updated : <b>{{ currentTemplate.update_time }}</b>
          </div>
        </div>
        <br /><br />
        <div
          class="vx-row"
          v-if="
            userInfo.userRole == 'Administrator' ||
            currentTemplate.createdBy == userInfo.uid ||
            userInfo.access.actions.includes('datapush-staff')
          "
        >
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-pen"
              @click="postData('update')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('datapush-update') ||
                userInfo.access.actions.includes('datapush-staff')
              "
              >Update Data Push Subscription</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              @click="postData('delete')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('datapush-delete') ||
                userInfo.access.actions.includes('datapush-staff')
              "
              >Delete Data Push Subscription</vs-button
            >
          </div>
        </div>
      </div>

      <br />
    </vs-popup>

    <!-- Server Logs and Status Section -->
    <vs-popup
      fullscreen
      title="Server Logs & Status"
      :active.sync="logsPopupActive"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-refresh-cw"
            @click="refreshServerLogs"
            >Refresh Logs</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="success"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-play"
            @click="startServerMonitoring"
            >Start Monitoring</vs-button
          >
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-button
            color="warning"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-pause"
            @click="stopServerMonitoring"
            >Stop Monitoring</vs-button
          >
        </div>
      </div>
      <br />

      <!-- Server Status Cards -->
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vx-card>
            <div class="text-center">
              <h4>LPJ Server</h4>
              <vs-chip :color="getServerStatusColor('LPJ')" class="mt-2">
                {{ getServerStatus('LPJ') }}
              </vs-chip>
            </div>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vx-card>
            <div class="text-center">
              <h4>XINHWA Server</h4>
              <vs-chip :color="getServerStatusColor('XINHWA')" class="mt-2">
                {{ getServerStatus('XINHWA') }}
              </vs-chip>
            </div>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vx-card>
            <div class="text-center">
              <h4>MPOB Server</h4>
              <vs-chip :color="getServerStatusColor('MPOB')" class="mt-2">
                {{ getServerStatus('MPOB') }}
              </vs-chip>
            </div>
          </vx-card>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vx-card>
            <div class="text-center">
              <h4>CIMA Server</h4>
              <vs-chip :color="getServerStatusColor('CIMA')" class="mt-2">
                {{ getServerStatus('CIMA') }}
              </vs-chip>
            </div>
          </vx-card>
        </div>
      </div>
      <br />

      <!-- Server Logs Table -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Server Logs">
            <vs-table stripe :data="serverLogs" max-height="400">
              <template slot="thead">
                <vs-th>Timestamp</vs-th>
                <vs-th>Server</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Message</vs-th>
                <vs-th>Response Time</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ tr.timestamp }}</vs-td>
                  <vs-td>{{ tr.server }}</vs-td>
                  <vs-td>
                    <vs-chip :color="getLogStatusColor(tr.status)">
                      {{ tr.status }}
                    </vs-chip>
                  </vs-td>
                  <vs-td>{{ tr.message }}</vs-td>
                  <vs-td>{{ tr.responseTime }}ms</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-half">
        <vs-button
          size="small"
          @click="addTemplate"
          v-if="
            userInfo.userRole == 'Administrator' ||
            userInfo.access.actions.includes('datapush-add') ||
            userInfo.access.actions.includes('datapush-staff')
          "
          >Add New Data Push</vs-button
        >
      </div>
      <div class="vx-col md:w-1/3 w-half">
        <vs-button
          size="small"
          color="success"
          icon-pack="feather"
          icon="icon-activity"
          @click="showServerLogs"
          >Server Logs & Status</vs-button
        >
      </div>
    </div>
    <br />
    <ejs-grid
      :dataSource="templateData"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :allowTextWrap="true"
      height="60vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :searchSettings="searchOptions"
      :toolbar="toolbarOptions"
      ref="userTemplateGrid"
      id="userTemplateGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column
          field="no"
          headerText="No."
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column
          field="customerName"
          headerText="Customer Name"
          textAlign="Left"
        ></e-column>
        <e-column
          field="remarks"
          headerText="Remarks"
          textAlign="Left"
        ></e-column>
        <e-column
          field="update_time"
          headerText="Updated"
          textAlign="Left"
          width="200"
        ></e-column>
        <e-column
          headerText="Manage"
          textAlign="Left"
          :template="cTemplate"
          width="120"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate5.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    flatPickr,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      alertType: '',
      initial: true,
      alertBoolean: false,
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      isLoading: false,
      mode: 'add',
      showExistingChannels: false,
      existingChannels: [],
      popupActive: false,
      popupTitle: 'Add New Data Push',
      logsPopupActive: false,
      templateData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${
            JSON.parse(localStorage.getItem('userInfo')).displayName
          } | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      currentTemplate: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      parameterFields: {
        groupBy: 'parameterGroup',
        text: 'parameterName',
        value: 'parameterIdx',
      },
      parameterFieldsStandard: { text: 'label', value: 'val' },
      parameterOptionsTypes: [
        {
          label: 'Standard',
          val: 'standard',
        },
        {
          label: 'Schenker',
          val: 'schenker',
        },
      ],
      parameterOptionsIdentifier: [
        {
          label: '>ROTIGT',
          val: '>ROTIGT',
        },
        {
          label: '<',
          val: '<',
        },
        {
          label: 'Time',
          val: 'Time',
        },
        {
          label: 'MYIGT',
          val: 'MYIGT',
        },
        {
          label: 'IGE',
          val: 'IGE',
        },
        {
          label: '',
          val: '',
        },
        {
          label: '10',
          val: 10,
        },
        {
          label: 'IGT',
          val: 'IGT',
        },
      ],
      parameterOptionsFormat: [
        {
          label: 'startIdentifier',
          val: 'startIdentifier',
        },
        {
          label: 'assetName',
          val: 'assetName',
        },
        {
          label: 'date',
          val: 'date',
        },
        {
          label: 'date2',
          val: 'date2',
        },
        {
          label: 'time',
          val: 'time',
        },
        {
          label: 'identifier2',
          val: 'identifier2',
        },
        {
          label: 'ignitionText',
          val: 'ignitionText',
        },
        {
          label: 'gpsText',
          val: 'gpsText',
        },
        {
          label: 'latitude',
          val: 'latitude',
        },
        {
          label: 'longitude',
          val: 'longitude',
        },
        {
          label: 'speed',
          val: 'speed',
        },
        {
          label: 'direction',
          val: 'direction',
        },
        {
          label: 'endIdentifier',
          val: 'endIdentifier',
        },
        {
          label: 'ignition',
          val: 'ignition',
        },
      ],
      parameterOptionsProtocol: [
        {
          label: 'UDP',
          val: 'UDP',
        },
        {
          label: 'TCP',
          val: 'TCP',
        },
        {
          label: 'HTTP',
          val: 'HTTP',
        },
      ],
      parameterFieldsGroups: {
        groupBy: 'groupGroup',
        text: 'name',
        value: 'id',
      },
      // Preset configurations
      presetConfigs: {
        LPJ: {
          name: 'LPJ (Lembaga Pelabuhan Johor)',
          protocol: 'UDP',
          ip: '210.48.155.139',
          port: 9001,
          type: 'standard',
          format: ['startIdentifier', 'assetName', 'date', 'time', 'latitude', 'longitude', 'speed', 'endIdentifier'],
          identifier: ['>ROTIGT', 'IGT'],
          separator: ','
        },
        XINHWA: {
          name: 'XINHWA',
          protocol: 'HTTP',
          ip: 'https://exinhwa.org/api',
          port: 0,
          type: 'standard',
          format: ['startIdentifier', 'assetName', 'date', 'time', 'latitude', 'longitude', 'speed', 'endIdentifier'],
          identifier: ['>ROTIGT', 'IGT'],
          separator: ','
        },
        MPOB: {
          name: 'MPOB',
          protocol: 'UDP',
          ip: '211.25.234.139',
          port: 10001,
          type: 'standard',
          format: ['startIdentifier', 'assetName', 'date', 'time', 'latitude', 'longitude', 'speed', 'endIdentifier'],
          identifier: ['>ROTIGT', 'IGT'],
          separator: ','
        },
        CIMA: {
          name: 'CIMA',
          protocol: 'HTTP',
          ip: 'https://gateway.cima.w-locate.com/api',
          port: 0,
          type: 'standard',
          format: ['startIdentifier', 'assetName', 'date', 'time', 'latitude', 'longitude', 'speed', 'endIdentifier'],
          identifier: ['>ROTIGT', 'IGT'],
          separator: ','
        },
        LPK: {
          name: 'LPK (Lembaga Pelabuhan Klang)',
          protocol: 'UDP',
          ip: '35.185.177.143',
          port: 9000,
          type: 'standard',
          format: ['startIdentifier', 'assetName', 'date', 'time', 'latitude', 'longitude', 'speed', 'endIdentifier'],
          identifier: ['>ROTIGT', 'IGT'],
          separator: ','
        }
      },
      // Server monitoring data
      serverStatus: {
        LPJ: 'online',
        XINHWA: 'online',
        MPOB: 'offline',
        CIMA: 'online',
        LPK: 'online'
      },
      serverLogs: [
        {
          timestamp: '2025-07-26 10:30:25',
          server: 'LPJ',
          status: 'success',
          message: 'Data push successful - 150 records sent',
          responseTime: 245
        },
        {
          timestamp: '2025-07-26 10:29:15',
          server: 'XINHWA',
          status: 'success',
          message: 'Data push successful - 89 records sent',
          responseTime: 189
        },
        {
          timestamp: '2025-07-26 10:28:45',
          server: 'MPOB',
          status: 'error',
          message: 'Connection timeout - server not responding',
          responseTime: 5000
        },
        {
          timestamp: '2025-07-26 10:27:30',
          server: 'CIMA',
          status: 'success',
          message: 'Data push successful - 203 records sent',
          responseTime: 312
        },
        {
          timestamp: '2025-07-26 10:26:20',
          server: 'LPK',
          status: 'success',
          message: 'Data push successful - 67 records sent',
          responseTime: 178
        }
      ],
      monitoringInterval: null
    };
  },
  computed: {},
  methods: {
    // Preset methods
    applyPreset(presetName) {
      const preset = this.presetConfigs[presetName];
      if (preset) {
        // Clear existing IP entries
        this.currentTemplate.ip = [];

        // Add the preset configuration
        this.currentTemplate.ip.push({
          name: preset.name,
          type: preset.type,
          protocol: preset.protocol,
          ip: preset.ip,
          port: preset.port,
          format: preset.format,
          identifier: preset.identifier,
          separator: preset.separator
        });

        this.$vs.notify({
          time: 4000,
          text: `Applied ${presetName} preset configuration`,
          color: 'success',
        });
      }
    },

    clearPreset() {
      this.currentTemplate.ip = [];
      this.$vs.notify({
        time: 4000,
        text: 'Cleared preset configuration',
        color: 'warning',
      });
    },

    // Server monitoring methods
    showServerLogs() {
      this.logsPopupActive = true;
      this.refreshServerLogs();
    },

    refreshServerLogs() {
      // Simulate fetching fresh logs from server
      this.isLoading = true;
      setTimeout(() => {
        // Add a new log entry to simulate real-time updates
        const newLog = {
          timestamp: new Date().toLocaleString(),
          server: 'LPJ',
          status: 'success',
          message: 'Data push successful - 45 records sent',
          responseTime: Math.floor(Math.random() * 300) + 100
        };
        this.serverLogs.unshift(newLog);

        // Keep only last 50 logs
        if (this.serverLogs.length > 50) {
          this.serverLogs = this.serverLogs.slice(0, 50);
        }

        this.isLoading = false;
        this.$vs.notify({
          time: 2000,
          text: 'Server logs refreshed',
          color: 'success',
        });
      }, 1000);
    },

    startServerMonitoring() {
      if (this.monitoringInterval) {
        this.$vs.notify({
          time: 3000,
          text: 'Monitoring is already active',
          color: 'warning',
        });
        return;
      }

      this.monitoringInterval = setInterval(() => {
        this.refreshServerLogs();
      }, 30000); // Refresh every 30 seconds

      this.$vs.notify({
        time: 3000,
        text: 'Server monitoring started',
        color: 'success',
      });
    },

    stopServerMonitoring() {
      if (this.monitoringInterval) {
        clearInterval(this.monitoringInterval);
        this.monitoringInterval = null;
        this.$vs.notify({
          time: 3000,
          text: 'Server monitoring stopped',
          color: 'warning',
        });
      }
    },

    getServerStatus(server) {
      return this.serverStatus[server] || 'unknown';
    },

    getServerStatusColor(server) {
      const status = this.serverStatus[server];
      switch (status) {
        case 'online':
          return 'success';
        case 'offline':
          return 'danger';
        case 'warning':
          return 'warning';
        default:
          return 'dark';
      }
    },

    getLogStatusColor(status) {
      switch (status) {
        case 'success':
          return 'success';
        case 'error':
          return 'danger';
        case 'warning':
          return 'warning';
        default:
          return 'dark';
      }
    },

    removeIP(index) {
      this.currentTemplate.ip.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed IP',
        color: 'success',
      });
    },
    addIP() {
      this.currentTemplate.ip.push({
        name: '',
        type: '',
        protocol: '',
        ip: '',
        port: 8000,
        format: [],
        identifier: [],
        separator: ',',
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty IP',
        color: 'success',
      });
    },

    validateTemplate() {
      const self = this;
      return new Promise((resolve, reject) => {
        if (self.currentTemplate.customerName.length < 5) {
          reject('Customer Name field is mandatory. Minimum 5 characters.');
        }
        if (self.currentTemplate.ip.length < 1) {
          reject('IP adding is mandatory. Minimum 1 set of IP.');
        }
        if (self.currentTemplate.groups.length < 1) {
          reject('Unit assignment is mandatory. Minimum 1 group of units.');
        }
        resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Data Push';
      self.currentTemplate = {
        customerName: '',
        units: [],
        assets: [],
        ip: [],
        groups: [],
        remarks: '',
        createdBy: self.userInfo.uid,
      };
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.popupTitle = `Update Data Push ${data.customerName}`;
      self.currentTemplate = {
        customerName: data.customerName,
        ip: JSON.parse(data.ip),
        groups: JSON.parse(data.groups),
        remarks: data.remarks,
        createdBy: data.createdBy,
        id: data.id,
        create_time: data.create_time,
        update_time: data.update_time,
      };
      self.popupActive = true;
    },
    getData() {
      const self = this;
      let staffAccess;
      axios
        .post(
          `https://api.igeotechgps.com/api-datapush/get-datapush/${self.userInfo.uid}/${self.userInfo.userRole}`,
          {
            adtlAccess: self.userInfo.access.actions.includes('datapush-staff'),
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('datapush-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-datapush/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                } else if (response.data.error) {
                } else {
                }
              });
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    postData(type) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      if (type == 'add') {
        url = 'https://api.igeotechgps.com/api-datapush/add-datapush';
        successText =
          'Note: Newly added Data Push could take upto 2 hours to activate';
        successTitle = 'Added New Data Push';
        failureText =
          'Could not add Data Push, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'update') {
        url = 'https://api.igeotechgps.com/api-datapush/update-datapush';
        successText =
          'Note: Updated Data Push configurations could take upto 2 hours to activate';
        successTitle = 'Updated Data Push';
        failureText =
          'Could not update Data Push, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'delete') {
        url = 'https://api.igeotechgps.com/api-datapush/delete-datapush';
        successText =
          'Note: Deleted Data Push could take upto 2 hours to de-activate';
        successTitle = 'Deleted Data Push';
        failureText =
          'Could not delete Data Push, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
        const text =
          'Data Push deletion action is PERMANENT & IRREVERSIBLE. Continue? ';
        if (confirm(text) == false) {
          return;
        }
      }

      if (type == 'add' || type == 'update') {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(url, successText, successTitle, failureText);
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: 'warning',
            });
          });
      } else {
        self.confirmPostData(url, successText, successTitle, failureText);
      }
    },
    confirmPostData(url, successText, successTitle, failureText) {
      const self = this;
      axios
        .post(url, {
          userInfo: self.userInfo,
          currentTemplate: self.currentTemplate,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'userTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Data Push - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.userTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'userTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Data Push - Listing.pdf',
        };
        this.$refs.userTemplateGrid.pdfExport(exportProperties);
      }
    },
  },
  watch: {},
  mounted() {
    this.getData();
    this.getData2();
  },
  beforeDestroy() {
    // Clean up monitoring interval when component is destroyed
    if (this.monitoringInterval) {
      clearInterval(this.monitoringInterval);
    }
  },
};
</script>

<style scoped>
.table-container {
  max-height: 300px;
  overflow-y: auto;
}

.fixed-header-table {
  width: 100%;
  border-collapse: collapse;
}

.fixed-header-table thead {
  background-color: #f3f3f3;
  position: sticky;
  top: 0;
  z-index: 1;
}

.fixed-header-table th,
.fixed-header-table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.fixed-header-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Server status card styles */
.vx-card {
  transition: all 0.3s ease;
}

.vx-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* Log table styles */
.vs-table {
  font-size: 0.9rem;
}

.vs-chip {
  font-size: 0.8rem;
  font-weight: 500;
}
</style>
